import { Award, Shield, Globe, Phone } from 'lucide-react';
export const teamMembers = [
  {
    name: "Dr. Sandeep Sharma",
    title: "Senior Consultant — Orthopedics & Joint Reconstruction",
    credentials: "MBBS, MS (Orthopedics), Fellowship in Joint Replacement",
    specialization: "Comprehensive trauma, joint preservation, arthroplasty & Ilizarov reconstructive surgeries",
    experience: "18+ Years",
    image: "/assets/onedrive/sandeep sharma.png",
    bio: "Dr. Sandeep delivers precise trauma management and advanced joint reconstruction strategies, blending joint preservation with modern arthroplasty.",
    educationTraining: [
      "MBBS – Nepalgunj Medical College, Banke (Kathmandu University) | 2004 – 2010",
      "MS Orthopedics – D. Y. Patil Medical College, Pune | 2011 – 2014",
      "Depuy Synthes Joint Replacement Fellowship – Jape Hospital, Kopargaon | 2017"
    ],
    professionalExperience: [
      "Trained under Dr. S. M. Sharma at Sharma Orthopedic Centre & Hospital",
      "Extensive experience in trauma care, joint preservation & arthroplasty",
      "Leads Ilizarov and limb salvage programs for complex deformities"
    ],
    memberships: [
      "Indian Orthopedic Association (IOA)",
      "Rajasthan Orthopedic Surgeons Association (ROSA)",
      "ASAMI India",
      "Limb Reconstruction Society of Rajasthan",
      "National Association of Interlocking Surgeons (NAILS)"
    ],
    expertise: [
      "Complex Trauma & Intra-articular Fractures",
      "Joint Preservation Surgeries",
      "Hip & Knee Arthroplasty",
      "Ilizarov for Nonunion & Malunion",
      "Deformity Correction & Limb Reconstruction",
      "Arthroscopy & Sports Medicine",
      "CTEV (Clubfoot) Correction",
      "Limb Salvage Surgeries"
    ],
    languages: ["Hindi", "English"],
    availability: "Tue - Sun • 10:00 AM – 6:00 PM",
    contact: "+91 77270 48951"
  },
  {
    name: "Dr. Ajay Singh Khara",
    title: "Lead Anaesthesiologist & Perioperative Specialist",
    credentials: "MBBS, MD (Anaesthesiology)",
    specialization: "General & regional anaesthesia for surgical and critical care pathways with advanced airway management",
    experience: "17+ Years",
    image: "/assets/onedrive/ajay singh kharra.png",
    bio: "Dr. Ajay orchestrates seamless operative experiences with evidence-based anaesthesia care and critical care vigilance.",
    educationTraining: [
      "MBBS – SMS Medical College, Jaipur | 2002 – 2007",
      "MD Anaesthesiology – RNT Medical College, Udaipur"
    ],
    professionalExperience: [
      "General anaesthesia care for high-risk surgical cases",
      "Expertise in difficult airway management & intubations",
      "Regional anaesthesia blocks for surgery and pain management"
    ],
    memberships: [],
    expertise: [
      "General Anaesthesia Protocols",
      "Critical Care & Perioperative Monitoring",
      "Difficult Airway Management",
      "Regional & Nerve Blocks",
      "Pain Management Pathways"
    ],
    languages: ["Hindi", "English"],
    availability: "Wed - Mon • 9:30 AM – 6:30 PM",
    contact: "+91 77270 48951"
  },
  {
    name: "Dr. Ali Hasan",
    title: "Consultant Orthopedic Surgeon — Trauma, Arthroplasty & Arthroscopy",
    credentials: "MBBS, MS (Orthopedics)",
    specialization: "Knee preservation, arthroplasty, minimally invasive trauma & limb reconstruction",
    experience: "15+ Years",
    image: "/assets/onedrive/Ali hassan.png",
    bio: "Dr. Ali Hasan combines precision arthroplasty with minimally invasive trauma corrections for durable, functional outcomes.",
    educationTraining: [
      "MBBS – Madurai Medical College, Madurai | 2001 – 2006",
      "MS Orthopedics – Dr. S. N. Medical College, Jodhpur | 2009 – 2012"
    ],
    professionalExperience: [
      "Consultant Orthopedics, S. K. Soni Hospital, Jaipur | 2012 – 2013",
      "Consultant Orthopedics, S. K. Government District Hospital | 2013 – 2015",
      "Consultant Orthopedic Surgeon specializing in trauma, arthroplasty & arthroscopy"
    ],
    memberships: [
      "Indian Orthopedic Association (IOA)",
      "Rajasthan Orthopedic Surgeons Association",
      "ASAMI India",
      "Limb Reconstruction Society of Rajasthan"
    ],
    expertise: [
      "Knee Preservation Surgeries",
      "Hip & Knee Arthroplasty",
      "Minimally Invasive Trauma (MIS/MIPPO)",
      "Ilizarov Surgery & LRS",
      "Deformity Correction",
      "Complex Trauma Management",
      "Revision for Nonunion & Malunion",
      "Infection & Limb Salvage Reconstruction"
    ],
    languages: ["Hindi", "English", "Urdu"],
    availability: "Mon - Fri • 11:00 AM – 5:00 PM",
    contact: "+91 77270 48951"
  },
  {
    name: "Dr. Manish Jangir",
    title: "Consultant — Sports Medicine & Arthroscopy",
    credentials: "MBBS, MS (Orthopedics), FNB Sports Medicine & Arthroscopy",
    specialization: "Comprehensive knee, shoulder, ankle and elbow arthroscopy with advanced sports injury rehab",
    experience: "12+ Years",
    image: "/assets/onedrive/manish jangir.png",
    bio: "Dr. Manish brings superspecialized arthroscopy expertise to protect athlete careers and restore peak performance.",
    educationTraining: [
      "MBBS – Government Medical College, Miraj, Maharashtra",
      "MS Orthopedics – SMS Medical College, Jaipur",
      "FNB (NBE) – Sports Medicine & Arthroscopy (2-year superspecialization)"
    ],
    professionalExperience: [
      "Completed post-graduation & senior residency in Orthopedics",
      "Superspecialized fellowship in sports injuries & arthroscopy",
      "Extensive exposure to shoulder/knee arthroscopy & ligament reconstruction"
    ],
    memberships: [],
    expertise: [
      "Knee Arthroscopy (ACL/PCL/MCL/PLC)",
      "Meniscus & Cartilage Preservation",
      "Patellar Instability Solutions",
      "Knee Preservation (HTO, DFO)",
      "Shoulder Arthroscopy & Rotator Cuff Repair",
      "Shoulder Replacement (Reverse & Hemi)",
      "Ankle & Elbow Arthroscopy",
      "Comprehensive Sports Injury Management",
      "Trauma Around the Shoulder"
    ],
    languages: ["Hindi", "English", "Marwari"],
    availability: "Mon - Sat • 10:00 AM – 4:00 PM",
    contact: "+91 77270 48951"
  }
];

export const teamHighlights = [
  {
    label: "Collective Experience",
    value: "59+ Years",
    detail: "Combined orthopedic leadership across arthroscopy, spine, foot & pediatric care",
    icon: Award
  },
  {
    label: "Centers of Excellence",
    value: "04 Focus Units",
    detail: "Sports medicine, spine, foot & ankle, pediatric orthopedics",
    icon: Shield
  },
  {
    label: "Languages Spoken",
    value: "4 Languages",
    detail: "Personal counselling in Hindi, English, Urdu & Marwari",
    icon: Globe
  },
  {
    label: "Emergency Coverage",
    value: "24/7 Consultants",
    detail: "Rapid response trauma & spine command team",
    icon: Phone
  }
];

